<template>
  <div class="tw-flex tw-flex-wrap stk-regap-2 stk-row-regap-0">
    <p
      v-for="item in displayedItems"
      :key="item"
    >
      {{ item }}
    </p>
    <p v-if="hasMore">
      <span class="show-more-link" @click="handleShowMore">
        {{ showMoreLabel }}
      </span>
    </p>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  show: {
    type: Number,
    default: 3,
  },
});

const showMore = ref(false);

const hasMore = computed(() => props.items.length > props.show);
const showMoreLabel = computed(() => showMore.value ? 'Show less' : `and ${props.items.length - props.show} more`);

const displayedItems = computed(() => {
  if (hasMore.value && !showMore.value) {
    return props.items.slice(0, 3);
  }

  return props.items;
});

const handleShowMore = () => {
  showMore.value = !showMore.value;
};
</script>

<style scoped>
.show-more-link {
  color: var(--stk-primary);
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
